import request from './http'



export default {
    // getCategoryById(data) {
    //   return request({
    //     url: '/user/login',
    //     method: 'post',
    //     data
    //   })
    // },
    // 新闻动态一级页面列表详情接口
    getCategoryById(params) {
        return request({
            url: '/materials/a/cms/api/getCategoryById',
            method: 'get',
            params
        })
    },


    // 新闻动态分类列表接口
    getArticleByIdNew(params) {
        return request({
            url: '/materials/a/cms/api/getNews',
            method: 'get',
            params
        })
    },


    // 企务公开 其他列表页面获取 列表数据接口
    getArticleDataLists(params) {
        return request({
            url: '/materials/a/cms/api/getArticleDataList',
            method: 'get',
            params
        })
    },



    // 人才中心菜单和第一个tab框显示的列表数据 数据接口
    getCategoryDataList(params) {
        return request({
            url: '/materials/a/cms/api/getCategoryDataList',
            method: 'get',
            params
        })
    },

    // 新闻动态分类列表接口
    getArticleById(params) {
        return request({
            url: '/materials/a/cms/api/getArticleById',
            method: 'get',
            params
        })
    },
    // 新闻动态获取详情接口
    getArticleData(params) {
        return request({
            url: '/materials/a/cms/api/getArticleData',
            method: 'get',
            params
        })
    },

    // 集团概况详情接口
    getArticle(params) {
        return request({
            url: '/materials/a/cms/api/getArticle',
            method: 'get',
            params
        })
    },

    // 控股企业
    getHoldingCompany(params) {
        return request({
            url: '/materials/a/cms/api/getHoldingCompany',
            method: 'get',
            params
        })
    },


    // 集团荣誉
    getRotation(params) {
        return request({
            url: '/materials/a/cms/api/getRotation',
            method: 'get',
            params
        })
    },
    //首页新闻动态
    getNewsInfo(params) {
        return request({
            url: '/materials/a/cms/api/getArticlelink',
            method: 'get',
            params
        })
    },

    // 发展历程
    getSynopsis(params) {
        return request({
            url: '/materials/a/cms/api/getSynopsis',
            method: 'get',
            params
        })
    },


    // 交流中心左侧视频
    getvisionOne(params) {
        return request({
            url: '/materials/a/cms/api/getvisionOne',
            method: 'get',
            params
        })
    },
    // 交流中心右侧
    getRotation(params) {
        return request({
            url: '/materials/a/cms/api/getRotation',
            method: 'get',
            params
        })
    },
    // 交流中心-领导信箱
    saveMail(params) {
        return request({
            url: '/materials/a/cms/api/saveMail',
            method: 'post',
            params
        })
    },
    // 全局搜索
    searchArticle(params) {
        return request({
            url: '/materials/a/cms/api/searchArticle',
            method: 'get',
            params
        })
    },


    // ?catId=95eb0bc1de584139b2ff27c2e2154322&&pageNum=1&pageSize=10
    // 获取 采购信息一级页面
    cgYiji(params) {
        return request({
            url: '/materials/a/cms/api/getProcorement',
            method: 'get',
            params
        })
    },


    // ?catId=338d62f89f6641c78f4ba196ac4500ac&pageNum=1&pageSize=10
    // 采购信息获取列表页数据
    cgList(params) {
        return request({
            url: '/materials/a/cms/api/getProcorementByCatId',
            method: 'get',
            params
        })
    },

    // 采购信息详情接口
    cgDetail(params) {
        return request({
            url: '/materials/a/cms/api/getProcorementData',
            method: 'get',
            params
        })
    },


    // materials/a/cms/api/getBrief?catId=d9d3117b06684dc38a89cbdbbe2b4911
    // 港建
    getProcorementData(params) {
        return request({
            url: '/materials/a/cms/api/getBrief',
            method: 'get',
            params
        })
    },


    // materials/a/cms/api/getContactList?catId=9e6274e05d4e40438c4a357704e3c56d
    // 联系我们
    telList(params) {
        return request({
            url: '/materials/a/cms/api/getContactList',
            method: 'get',
            params
        })
    },

    // materials/a/cms/api/getContactListByBusiness?businessId=a2128866f1594bccb95f4567adcaca13
    tel2List(params) {
        return request({
            url: '/materials/a/cms/api/getContactListByBusiness',
            method: 'get',
            params
        })
    },


    // 党群纪检首页轮播图接口
    dqjjLunbo(params) {
        return request({
            url: '/materials/a/cms/api/getArticlelink',
            method: 'get',
            params
        })
    },


}